import React, { createContext, useMemo } from "react";
import PropTypes from "prop-types";

export const ProductsContext = createContext();

export const ProductsProvider = ({ children, gwProducts, setGWProducts }) => {
  const value = useMemo(
    () => ({ gwProducts, setGWProducts }),
    [gwProducts, setGWProducts]
  );
  return (
    <ProductsContext.Provider value={value}>
      {children}
    </ProductsContext.Provider>
  );
};

ProductsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  gwProducts: PropTypes.array,
  setGWProducts: PropTypes.func.isRequired,
};
